module.exports = __webpack_public_path__ + "static/media/21ECLAC21.fa6f0514.jpg";